// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { html as htmljs } from 'fxjs/es';
import { FanLetterData } from '../../../../../../../services/MarppleShop/features/FanLetter/type';
import { FanLetterItemView } from '../../../../../../../services/MarppleShop/renderApp/components/cells/FanLetterItem/FanLetterItemView';
import { font } from '../../../../../../../services/MarppleShop/shared/typography';
import { CreatorCardType } from '../../../../../../../services/MarppleShop/features/Creator/type';
import { SectionTitle } from '../../../../../../../services/MarppleShop/renderApp/components/cells/SectionTitle/SectionTitle';
import {
  SeeMoreLinkPlugin,
  ArrowPlugin,
} from '../../../../../../../services/MarppleShop/renderApp/components/cells/SectionTitle/plugins';
import { html } from 'rune-ts';
import { makeEmptyScreenNavigate } from '../../../../../../../services/MarppleShop/shared/app/navigate';
import { humanReadableNumberV2 } from '../../../../../../../shared/utils/formatter';

export const makeFanLetterMoreLinkPlugin = (store_domain: string, is_mobile: boolean) => {
  const uri = `/${ET.lang}/${store_domain}/fan-letter`;
  return new SeeMoreLinkPlugin({
    see_more_link: uri,
    navigate: makeEmptyScreenNavigate(uri),
    size: is_mobile ? 'xSmall' : 'medium',
  });
};

export const makeProductDetailFanLetterTittle = ({
  like_count,
  store_name,
  is_mobile,
}: {
  like_count: number;
  store_name: string | null;
  is_mobile: boolean;
}) => {
  const { value, unit } = humanReadableNumberV2.to(like_count, ET.lang === 'kr');
  return html.preventEscape(`
    <div
      class="product-detail-fanletter-title"
      data-like_count="${like_count}"
      data-is_mobile="${is_mobile}"
      data-store_name="${store_name}"
    >
      ${html.preventEscape(
        like_count > 9
          ? ET(`creator_shop::fan_letters::pd_title`, {
              like_count: value + unit,
            })
          : ET(`creator_shop::fan_letters::pd_title_zero`),
      )}
    </div>
  `);
};

export const makeFanLetterPreview = ({
  fan_letters,
  is_login,
  is_mobile,
  store: { name: store_name, like_count, domain_name: store_domain },
}: {
  fan_letters: FanLetterData[];
  is_login: boolean;
  is_mobile: boolean;
  store: CreatorCardType;
}) => {
  if (!fan_letters?.length) {
    return '';
  }

  return htmljs`<div class="pd-contents__fan-letter-preview">
    <div class="pd-contents__fan-letter-preview-header">
      ${new SectionTitle({
        ssr: true,
        title_props: {
          title: makeProductDetailFanLetterTittle({ like_count, store_name, is_mobile }),
          size: is_mobile ? 'xSmall' : 'medium',
        },
        plugins:
          !is_mobile && fan_letters.length > 4
            ? [makeFanLetterMoreLinkPlugin(store_domain, is_mobile), new ArrowPlugin()]
            : [makeFanLetterMoreLinkPlugin(store_domain, is_mobile)],
      }).toHtmlSSR()}
    </div>
    <div class="pd-contents__fan-letter-preview-items">
      ${
        is_mobile
          ? htmljs`<a
            href="/${ET.lang}/${store_domain}/fan-letter"
            class="pd-contents__fan-letter-preview-form swiper-slide"
          >
            <img
              src="//s3.marpple.co/files/u_29089/2025/4/original/88066470e0b18d222daeb643bb5d7816e125eb841.svg"
              alt=""
            />
            <span class="pd-contents__fan-letter-preview-form-title ${font('12_medium')}">${ET(`creator_shop::fan_letters::write`)}</span>
          </a>`
          : ''
      }
      <div class=" swiper-container" data-len="${fan_letters.length}">
        <div class="swiper-wrapper">
          ${fan_letters
            .map((fan_letter) => {
              return htmljs`<div class="swiper-slide">
                ${new FanLetterItemView(
                  { ...fan_letter, is_login },
                  {
                    profile_horizontal: true,
                    mode: is_mobile ? 'Small' : 'Medium',
                  },
                ).toHtmlSSR()}
              </div>`;
            })
            .join('')}
        </div>
      </div>
    </div>
  </div>`;
};
